import { KNOWN_ERROR_CODES, KNOWN_ERROR_MESSAGES } from 'logging/constants';

export default error => {
  const { code, message } = error;

  const stringMessage =
    typeof message === 'object' ? JSON.stringify(message) : String(message);

  return !(
    (code && KNOWN_ERROR_CODES.includes(code)) ||
    (message &&
      KNOWN_ERROR_MESSAGES.find(errorMessage =>
        stringMessage.includes(errorMessage)
      ))
  );
};
